import axios from "axios";

const instance = axios.create({
  withCredentials: true, //ini wajib ada utk cookie base session
  baseURL: import.meta.env.VITE_BACKEND_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default instance;